import React from 'react';
import Services from '../components/Services';

const ServicesPage = () => {
  return (
    <div className="min-h-screen">
      <Services />
    </div>
  );
};

export default ServicesPage;
